
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 15","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.375 3.047c0 .11.027.191.082.246.055.055.137.082.246.082h11.594a.31.31 0 00.219-.082.347.347 0 00.109-.246V2.28c0-.164-.082-.328-.191-.465-.137-.109-.301-.191-.465-.191H8.906l-.246-.52A.537.537 0 008.414.86.891.891 0 008.06.75H4.94c-.136 0-.246.055-.355.11a.537.537 0 00-.246.245l-.246.52H1.03a.66.66 0 00-.465.191.64.64 0 00-.191.465v.766zm11.348 1.558c0-.082-.055-.164-.11-.246-.054-.054-.136-.109-.218-.109h-9.79a.347.347 0 00-.246.11.441.441 0 00-.082.245l.547 8.915c0 .355.137.656.41.875.246.246.547.355.903.355h6.726c.328 0 .63-.11.903-.355.246-.22.382-.52.41-.875l.547-8.915z"}})])
          )
        }
      }
    